/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Breadcrumb from '@ion/dls/src/components/breadcrumbs/Breadcrumbs';
import {
  FilterContentGrid,
  FilterContentList
} from './FilterContent';
import {FilterExpandContentProps} from './FilterExpandContent';
import FilterHeader from './FilterHeader';
import {
  FilterSelectedOptions,
  FilterSelectedOptionsTitle
} from './FilterSelectedOptions';

export interface FilterMobileExpandContentProps extends FilterExpandContentProps {
  isTree: boolean;
}

export const FilterMobileExpandContent = ({
  isTree,
  classes,
  children,
  treeProps,
  rawCrumbs,
  optionType,
  hasSelection,
  filterHashMap,
  contentGridRowGap,
  filterClearSearch,
  contentGridColumnGap,
  filterSelectedOptions,
  contentJustifyContent,
  showSelectedOptionsCount,
  filterSelectedOptionsCount,
  contentGridTemplateColumns,
  crumbData = null,
  filterSearchValue = '',
  filterContentOptions = [],
  handleCrumbBack,
  handleChipDelete,
  clearSearchValue,
  setFilterClearSearch,
  handleToggleSelectAll,
  handleSearchValueChange,
  handleContentGroupSelected,
  handleContentOptionSelected
}: FilterMobileExpandContentProps) => {
  return (
    <>
      <div className={classes.filterHeaderBar}>
        <FilterHeader clearSearch={filterClearSearch}
          onSearchValueChange={handleSearchValueChange}
          onToggleSelectAll={handleToggleSelectAll} />
      </div>
      <div>
        <div id='chipsContainer' className={classes.chipsContainer}>
          {hasSelection && (
            <FilterSelectedOptionsTitle optionType={optionType}
              selectedOptionsCount={filterSelectedOptionsCount}
              showSelectedOptionsCount={showSelectedOptionsCount} />
          )}
          <FilterSelectedOptions selectedOptions={filterSelectedOptions}
            selectedOptionsCount={filterSelectedOptionsCount}
            optionData={filterHashMap}
            numberChipsLimit={1}
            onChipDelete={handleChipDelete} />
        </div>
        {!isTree && filterSearchValue.length === 0
          ? <>
            <div className={classes.crumbsContainer}>
              <Breadcrumb icon={(rawCrumbs.length > 1) &&
                      <ChevronLeft className={classes.chevron} />}
              iconClick={handleCrumbBack}>
                {crumbData}
              </Breadcrumb>
            </div>
            <div className={classes.contentContainer}>
              <FilterContentGrid optionItems={filterContentOptions}
                optionData={filterHashMap}
                onOptionSelected={handleContentOptionSelected}
                onGroupSelected={handleContentGroupSelected}
                contentGridTemplateColumns={contentGridTemplateColumns}
                contentJustifyContent={contentJustifyContent}
                contentGridColumnGap={contentGridColumnGap}
                contentGridRowGap={contentGridRowGap} />
            </div>
          </>
          : (
            <div className={classes.contentContainer}>
              <FilterContentList searchValue={filterSearchValue}
                optionType={optionType}
                optionItems={filterContentOptions}
                optionData={filterHashMap}
                clearSearchValue={clearSearchValue}
                onOptionSelected={handleContentOptionSelected}
                onGroupSelected={handleContentGroupSelected} />
            </div>
          )
        }
      </div>
    </>
  );
};
